/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RequestAdditionalQuotesResponse
 */
export interface RequestAdditionalQuotesResponse {
  /**
   *
   * @type {string}
   * @memberof RequestAdditionalQuotesResponse
   */
  quoteGroupId: string;
}

/**
 * Check if a given object implements the RequestAdditionalQuotesResponse interface.
 */
export function instanceOfRequestAdditionalQuotesResponse(
  value: object,
): value is RequestAdditionalQuotesResponse {
  if (!("quoteGroupId" in value) || value["quoteGroupId"] === undefined)
    return false;
  return true;
}

export function RequestAdditionalQuotesResponseFromJSON(
  json: any,
): RequestAdditionalQuotesResponse {
  return RequestAdditionalQuotesResponseFromJSONTyped(json, false);
}

export function RequestAdditionalQuotesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestAdditionalQuotesResponse {
  if (json == null) {
    return json;
  }
  return {
    quoteGroupId: json["quoteGroupId"],
  };
}

export function RequestAdditionalQuotesResponseToJSON(
  json: any,
): RequestAdditionalQuotesResponse {
  return RequestAdditionalQuotesResponseToJSONTyped(json, false);
}

export function RequestAdditionalQuotesResponseToJSONTyped(
  value?: RequestAdditionalQuotesResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    quoteGroupId: value["quoteGroupId"],
  };
}
